module.exports = __webpack_public_path__ + "static/media/thumbnail.2edef56c.svg";